import * as React from 'react';

const SvgFilter = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M23.89.55A1 1 0 0023 0H1a1 1 0 00-.89.55A1 1 0 00.2 1.6L9 13.42V22a2 2 0 002 2 2 2 0 001.2-.4l2-1.5a2 2 0 00.8-1.6v-7.08L23.8 1.6a1 1 0 00.09-1.05zM5.42 2.2l3.94 5.25a.54.54 0 01.1.3V9a.49.49 0 01-.34.47.48.48 0 01-.56-.17L3.62 2.8a.49.49 0 01-.05-.52A.5.5 0 014 2h1a.54.54 0 01.42.2z" />
    </svg>
  );
};

export default SvgFilter;
